import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedArticles from './components/FeaturedArticles';
import StatsSection from './components/StatsSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import SchemaOrg from '@/components/base/SchemaOrg';
import { faqItems } from '@/mocks/faq';

export default function Home() {
  return (
    <>
      <SchemaOrg type="WebSite" />
      <SchemaOrg type="Organization" />
      <SchemaOrg type="WebPage" data={{ name: '蓝色导航发布页 - 首页', description: '专业内容发布与网站导航平台' }} />
      <SchemaOrg type="FAQPage" data={{ questions: faqItems }} />

      <main>
        <HeroSection />
        <CategoryGrid />
        <FeaturedArticles />
        <StatsSection />
        <FAQSection />
        <CTASection />
      </main>
    </>
  );
}